import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import {default as Reactsel} from 'react-select';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';

class AdminUpdateCourseEntities extends Component {

  constructor(props) {
    super(props);
    this.state ={
      data: {
        itemName: '',
        itemDescription: '',
        currency: 'RS',
        active: '',
        imgLink: '',
        revenueShare: '',
        selectedItemParent: [],
        startDate: '',
        endDate: '',
        hours: '',
        minutes: '',
        competencyList: [],
        selectedCompetency: [],
        selectedPurchaseItemMappingArray: [],
        destroypurchaseItemMappingArray: [],
        disableForSelfPaced: true
      },
      saveDisable: false,
      errorMsg: '',
    }
  }

  componentDidMount() {
    let purchaseItemId = this.props.match.params.id
    let data = Object.assign({}, this.state.data)
    api.getResponse(this.props.user.accessToken, 'admin/taxonomy_details/2')
      .then((result) => {
        if(result.status === 'success'){
          data.competencyList = result.data
        }
        return api.getEntityForUpdate(this.props.user.accessToken, purchaseItemId)
      })
      .then((result) => {
        if(result.status === 'success') {
          data.itemName = result.data.name ? result.data.name : ''
          data.itemDescription = result.data.description ? result.data.description : ''
          data.currency = result.data.currency ? result.data.currency : ''
          data.itemPrice = result.data.amount ? result.data.amount : ''
          data.imgLink = result.data.img_link ? result.data.img_link : ''
          data.revenueShare = result.data.revenue_share ? result.data.revenue_share : ''
          data.selectedItemParent = result.parents ? result.parents :  ''
          data.startDate = result.data.start_date ? result.data.start_date.split('T')[0] : ''
          data.endDate = result.data.end_date ? result.data.end_date.split('T')[0] : ''
          if (result.data.entity_type === 'SELF PACED') {
            data.disableForSelfPaced = true
          } else {
            data.disableForSelfPaced = false
          }
          if (result.data.duration) {
            data.hours = result.data.duration.split(':')[0] ? result.data.duration.split(':')[0] : ''
            data.minutes = result.data.duration.split(':')[1] ? result.data.duration.split(':')[1] : ''
          }

          data.purchaseItemMappings = result.purchase_item_mapping ? result.purchase_item_mapping : ''
            let selectedCompetency = data.competencyList.filter((competency) => data.purchaseItemMappings.some(purchaseItemMapping => purchaseItemMapping.item_id === competency.value));   
            data.selectedCompetency = selectedCompetency
            let selectedPurchaseItemMappingArray = []
            let finalArray = data.purchaseItemMappings.filter(competency => data.selectedCompetency.some(selectedCompetency => competency.item_id === selectedCompetency.value)); 
            selectedPurchaseItemMappingArray.push(finalArray)
            data.selectedPurchaseItemMappingArray = selectedPurchaseItemMappingArray
          if(result.data.active === true){
            data.active = 1
          }
          else if(result.data.active === false){
            data.active = 0
          }
        }
        this.setState({data: data})
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Exception in Fetching Details'})
      })
  }

  onInputChange = evt => {
    let data = Object.assign({}, this.state.data)
    data[evt.target.name] = evt.target.value
    this.setState({data: data})
  }; 

  handleCompetencyChange = (option) => {
    let data = Object.assign({}, this.state.data)
    data.selectedCompetency = option
    this.setState({ data })
  }


  onActiveChange = evt => {
    let data = Object.assign({}, this.state.data)
    data.active = evt.target.value
    this.setState({data: data})
  };

  handlePurchaseItemUpdate = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)

    const reg = new RegExp('^[0-9]+$');
    if(data.disableForSelfPaced) {
      if(
        data.itemName === '' || data.itemDescription === '' || data.itemPrice === '' ||
        data.currency === '' || data.active === '' || data.imgLink === ''  || data.selectedCompetency.length === 0
      ){
        return this.setState({errorMsg: 'All the fields are mandatory except start date, end date, and duration'})
      } 
    }
    else {
      if(
        data.itemName === '' || data.itemDescription === '' || data.itemPrice === '' ||
        data.currency === '' || data.active === '' || data.imgLink === ''  || data.startDate === '' || data.endDate === '' || !data.hours || !data.minutes || data.selectedCompetency.length === 0
      ){
        return this.setState({errorMsg: 'All the fields are mandatory'})
      } else if (reg.test(data.hours) === false && reg.test(data.minutes) === false) {
        return this.setState({ errorMsg: 'Hours and Minutes is not valid' })
      } else if (reg.test(data.hours) === false) {
        return this.setState({ errorMsg: 'Hours is not valid' })
      } else if (reg.test(data.minutes) === false) {
        return this.setState({ errorMsg: 'Minutes is not valid' })
      } else if (data.minutes > 59) {
        return this.setState({ errorMsg: 'Minutes should not be greater than 59' })
      }
    }
    let itemId = this.props.match.params.id
    let values;
    values = {
      'name': this.state.data.itemName,
      'description': this.state.data.itemDescription,
      'currency': this.state.data.currency,
      'amount': parseInt(this.state.data.itemPrice),
      'active': parseInt(this.state.data.active),
      'img_link': this.state.data.imgLink,
      'revenue_share': this.state.data.revenueShare
    }

    if (!data.disableForSelfPaced) {
      values.start_date = data.startDate,
      values.end_date = data.endDate,
      values.duration = `${data.hours}:${data.minutes}`
    }

    let finalSelectedCompetency = [], destroypurchaseItemMappingArray = []

    if (data.selectedCompetency && data.selectedCompetency.length > 0) {
      data.selectedCompetency.map( (competency) => {

       let id =  data.selectedPurchaseItemMappingArray[0]
        .filter( (eachItem) => {
          return eachItem.item_id === competency.value
        })
        .map( (finalObject) => {
          return finalObject.id
        })

        finalSelectedCompetency.push({
          "id": parseInt(id),
          "item_type": "Learning Taxonomy",
          "active" : 1,
          "item_id": competency.value,
          "_destroy": 0,
        })
      })
    } 


    let destroyCompetencyArray = data.purchaseItemMappings.filter(competency => !data.selectedCompetency.some(selectedCompetency => competency.item_id === selectedCompetency.value)); 
    destroyCompetencyArray.forEach( (eachcompetency) => {
      eachcompetency._destroy = 1
    });
    
    let finalPurchaseItemAttributes = [...finalSelectedCompetency, ...destroyCompetencyArray]  
    values.purchase_item_mappings_attributes = finalPurchaseItemAttributes
    api.updatePurchaseItem(this.props.user.accessToken, itemId, values)
      .then((result) => {
        if (result.status === 'success'){
          this.setState({errorMsg: result.message, saveDisable: true})
          return
        }
        else{
            this.setState({errorMsg: result.message, saveDisable: false})
        }
      })
  }

  onCurrencyNameChange = evt => {
    let data = Object.assign({}, this.state.data)
    data.currency = evt.target.value
    this.setState({data: data})
  };

  render() {
    let data = Object.assign({}, this.state.data)
    let activeComponent = (
      <Select
        onChange={this.onActiveChange} 
        value={this.state.data.active}
      >
        <option value = "1">Active</option>
        <option value = "0">Inactive</option>
      </Select>
    )
    let currencyComponent = (
      <Select
        onChange={this.onCurrencyNameChange} 
        value={this.state.data.currency}
      >
        <option value = 'RS'>RS</option>
      </Select>
    )

    return(
      <div>
        <Grid>
          <GridCell span="12">
            <form onSubmit= {this.handlePurchaseItemUpdate}>
              <GridCell span="12">
                <TextField fullwidth label="Name" autoComplete="off" name="itemName" onChange={this.onInputChange} value={this.state.data.itemName} style={{ height: '140%' }}/>
              </GridCell>
              <GridCell span="12">
                <TextField fullwidth label="Description" autoComplete="off" name="itemDescription" onChange={this.onInputChange} value={this.state.data.itemDescription} style={{ height: '140%' }}/>
              </GridCell>
              {currencyComponent}
              <GridCell span="12">
                <TextField fullwidth label="Price" autoComplete="off" name="itemPrice" onChange={this.onInputChange} value={this.state.data.itemPrice} style={{ height: '140%' }}/>
              </GridCell>
              <GridCell span="12">
                <TextField fullwidth label="Image Link" autoComplete="off" name="imgLink" onChange={this.onInputChange} value={this.state.data.imgLink} style={{ height: '140%' }}/>
              </GridCell>
              <GridCell span="12">
                <TextField fullwidth label="Centa Revenue Share" type="number" autoComplete="off" name="revenueShare" onChange={this.onInputChange} value={this.state.data.revenueShare} style={{ height: '140%' }}/>
              </GridCell>
              <GridCell span="12">
                <TextField type="date" className="datepicker-padding" label="Start Date" autoComplete="off" name="startDate" onChange={this.onInputChange} 
                  disabled={data.disableForSelfPaced} value={this.state.data.startDate}/>
              </GridCell>
              <GridCell span="12">
                  <TextField type="date" className="datepicker-padding" label="End Date" autoComplete="off" name="endDate" onChange={this.onInputChange} 
                  disabled={data.disableForSelfPaced} value={this.state.data.endDate}/>
              </GridCell>
              <GridCell span="12">
                <label style={{ marginRight: '4rem' }}>Duration:</label>
                <TextField className='text_input' type="number" label="Hours" autoComplete="off" name="hours" onChange={this.onInputChange}
                  disabled={data.disableForSelfPaced} value={this.state.data.hours} />
                <span style={{ marginLeft: '1rem', marginRight: '1rem' }}> : </span>
                <TextField className='text_input' type="number" label="Minutes" autoComplete="off" name="minutes" onChange={this.onInputChange}
                  disabled={data.disableForSelfPaced} value={this.state.data.minutes} />
              </GridCell>
            <br/>
            <GridCell span="12">
              <Reactsel 
                name="selectedCompetency"
                onChange={this.handleCompetencyChange}
                value={data.selectedCompetency}
                options={data.competencyList}
                placeholder="-- Select Competency --"
                isMulti>
              </Reactsel>
            </GridCell>
            <br/>

              {activeComponent}
              <br/>
              <GridCell span = "12">
                <Reactsel
                        name="purchaseItemList"
                        value={this.state.data.selectedItemParent}
                        placeholder="--Select Course Item Parent--"
                        isMulti>
                </Reactsel>
              </GridCell>
              <br/>
              <Button raised disabled={this.state.saveDisable}>Save</Button>
            </form>
          </GridCell>
        </Grid>
        <StatusMessage error_msg = {this.state.errorMsg} />
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdateCourseEntities);


// WEBPACK FOOTER //
// ./src/views/admin/AdminUpdateCourseEntities.jsx